import { Alert } from "antd";
import Vocabulary from "components/Vocabulary";
import _ from "lodash";
import React from "react";
import { FieldTypes } from "utils/formUtils";
import { Approvers, emailValidator } from "../Exception/ExceptionDetails/EditApprovalPopupV2/EditApprovalPopupV2";

export const isTypeExceptionPresent = (types) =>_.some(types, isTypeException);
export const isTypeException = (projectType) => projectType === "Exception";

export const getApprovalWorkflowFields = ({ approvalUsers, disabled = false, newApprovalFlow, userContext }) => {
    return [
    ...(disabled ? [{
        name: "",
        render: () => <Alert className="m-b-m" type='warning' description={<>
            For <Vocabulary name= "exception"/> with scope defined, workflow needs to be defined under the <Vocabulary name="team" /> that owns the <Vocabulary name="subProduct" />
        </>} />
    }] : []), {
        value: <div className='w-100 d-flex'><div className='w-50'>Available user(s)/role(s)</div><div className="p-l-l">Selected user(s)/role(s) with approval order</div></div>,
        type: FieldTypes.LABEL,
        noStyle: true
    }, 
    ...(newApprovalFlow ? 
          [{
            name: "approvers",
            label: "",
            render: () => <Approvers dataSource={approvalUsers} />,
            colSpan: 24,
            style: { marginBottom: 10 },
            rules: [{
              validator: (rule, values) => emailValidator(rule, values, userContext.sessionData)
            }]
          }] : [{
            name: 'approvers',
            label: '',
            type: FieldTypes.TRANSFER,
            props: {
                disabled,
                makeDraggableSort: true,
                dataSource: _.map(approvalUsers, entry => ({ key: entry.value, title: `${entry.label}${entry.type === 'ROLE' ? '(Role)' : ''}`, }))
            }
        }] 
    ),
    {
        name: 'subscriberUserIds',
        label: 'Send Updates To',
        type: FieldTypes.TAGS,
        props: {
            disabled,
        },
        options: approvalUsers.filter(entry => entry.type !== 'ROLE')
    }]
}
